import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

export const StyledAvatarBox = createPrefixedPropsFilteredComponent<{ $padding: string }>(Box)(({ $padding }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: $padding
}));

export const StyledAccountIcon = createPrefixedPropsFilteredComponent<{ $fontSize: string; $color: string }>(AccountCircleIcon)(({ $fontSize, $color }) => ({
  fontSize: $fontSize,
  color: $color,
  fill: $color
}));

export {};

// ... existing code ... 